export default "__VITE_ASSET__DN6Ca7c1__"